<template>
    <div>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div aria-controls="filterForm" class="card-title collapsed"
                         data-target="#filterForm"
                         data-toggle="collapse">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <kt-panel>
                    <div aria-labelledby="filterForm" class="collapse" data-parent="#userFilter" id="filterForm">
                        <div class="card-body">
                            <form @submit.prevent="filterAction($event, query)">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col class="mb-2" md="4" sm="4" xs="12">
                                            <label for="type"
                                                   v-text="$t('label.type')"
                                            >
                                            </label>
                                            <select id="type" class="form-control" name="type" v-model="query.transaction_type"
                                            >
                                                <option :value="null" selected v-text="$t('label.all_types')"
                                                ></option>
                                                <option :value="transmitType.debit"
                                                        v-text="transmitTypeStr.get(transmitType.debit)"
                                                ></option>
                                                <option :value="transmitType.credit"
                                                        v-text="transmitTypeStr.get(transmitType.credit)"
                                                ></option>
                                            </select>
                                        </kt-col>
                                        <kt-col class="mb-2" md="4" sm="4" xs="12">
                                            <label for="bank_account"
                                                   v-text="$t('label.bank_account')"
                                            >
                                            </label>
                                            <select class="form-control kt-selectpicker" id="bank_account" name="bank_account"
                                                    v-model="query.bank_account">
                                                <option :value="null" selected v-text="$t('label.default')"
                                                ></option>
                                                <option :key="index" :value="account.number"
                                                        v-for="(account, index) in parsian_banks"
                                                        v-text="account.number + ' (' + account.fa_name + ')'"
                                                >
                                                </option>
                                            </select>
                                        </kt-col>
                                        <kt-col class="mb-2" md="4" sm="4" xs="12">
                                            <label for="description"
                                                   v-text="$t('label.description')"
                                            >
                                            </label>
                                            <select id="description" class="form-control" name="description" v-model="query.describe_transaction"
                                            >
                                                <option :value="null" selected v-text="$t('label.all_types')"
                                                ></option>
                                                <option :value="transmitDescription.internal"
                                                        v-text="transmitDescriptionStr.get(transmitDescription.internal)"
                                                ></option>
                                                <option :value="transmitDescription.paya"
                                                        v-text="transmitDescriptionStr.get(transmitDescription.paya)"
                                                ></option>
                                                <option :value="transmitDescription.reversal"
                                                        v-text="transmitDescriptionStr.get(transmitDescription.reversal)"
                                                ></option>
                                                <option :value="transmitDescription.s719"
                                                        v-text="transmitDescriptionStr.get(transmitDescription.s719)"
                                                ></option>
                                            </select>
                                        </kt-col>
                                        <kt-col class="mb-2" md="4" sm="4" xs="12">
                                            <label for="amount"
                                                   v-text="$t('label.amount')"
                                            >
                                            </label>
                                            <input class="form-control" id="amount" v-model="query.amount">
                                        </kt-col>
                                        <kt-col class="mb-2" md="4" sm="4" xs="12">
                                            <label for="from_date"
                                                   v-text="$t('label.from_date')"
                                            >
                                            </label>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "query.from_date"
                                                    v-model="query.from_date"
                                                    type="datetime" />
                                        </kt-col>
                                        <kt-col class="mb-2" md="4" sm="4" xs="12">
                                            <label for="to_date"
                                                   v-text="$t('label.to_date')"
                                            >
                                            </label>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name= "query.to_date"
                                                    v-model="query.to_date"
                                                    type="datetime" />
                                        </kt-col>
                                    </kt-form-row>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6" class="mt-4">
                                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                            <input type="button" @click="excel_export($event, query)" class="btn btn-primary btn-wide mx-2" :value="$t('label.excel_export')">
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                    <div class="line-divider my-3"></div>
                    <kt-panel-body>
                        <kt-datatable ref="datatable" v-bind="datatableProps">
                        </kt-datatable>
                    </kt-panel-body>
                </kt-panel>
            </div>
        </div>
    </div>
</template>

<script>
    import {ApiUrl, walletService} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import {transmitDescription, transmitDescriptionStr} from '@/constants/transmitDescription';
    import {transmitType, transmitTypeStr} from "@/constants/transmitType";
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import {KTApp} from "@/plugins/core/app";
    import axios from "axios";
    import parsianColumns from "@/views/wallets/AyandeWallets/Admin/components/statements/columns/parsian-columns";

    export default {
        props: {
            fetch_starshop: {
                default: false,
                type: Boolean
            },
            api_base_path: {
                default: ApiUrl.path(''),
                type: String
            }
        },
        data() {
            return {
                transmitType,
                transmitTypeStr,
                transmitDescription,
                transmitDescriptionStr,
                parsian_banks: [],
                query: {
                    type: null,
                    description: null,
                    bank_account: '',
                    from_date: '',
                    to_date: '',
                },
            };
        },
        mounted() {
            const parsianBankAccounts  = this.fetch_starshop
                ? walletService.getStarShopAllWalletParsianBanks
                : walletService.getAllWalletParsianBanks;

            parsianBankAccounts().then(res => {
                this.parsian_banks = res.data.data.all_parsian_bank_accounts;
                this.initSelectPicker();
            });
        },
        methods: {
            excel_export(e, query) {
                let btn = $(e.target);
                KTApp.progress(btn);
                this.query = query;

                axios({
                    url: this.api_base_path + 'wallet/common/admin/bank/parsian/excel-export',
                    method: 'GET',
                    params: this.query,
                    responseType: 'blob',
                }).then(response => {
                    let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    let fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', `parsian_${query.bank_account}_from_${query.from_date}_to_${query.to_date}.xlsx`);
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    KTApp.unprogress(btn)
                }).finally(() => {
                    KTApp.unprogress(btn)
                });
            },
            initSelectPicker() {
                setTimeout(() => {
                    $('.kt-selectpicker').selectpicker({
                        size: 4,
                        liveSearch: true,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_selected')
                    })
                }, 1000);
            },
            filterAction(e, query) {
                if (this.query.from_date != null && this.query.to_date == null) {
                    alert(i18n.t('wallets.error.when_from_date_is_filled_to_date_should_be_filled'));

                    return;
                }

                if (this.query.from_date == null && this.query.to_date != null) {
                    alert(i18n.t('wallets.error.when_to_date_is_filled_from_date_should_be_filled'));

                    return;
                }

                this.query = query;

                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }
            },
        },
        computed: {
            datatableProps() {
                return {
                    id: 'saderat_statement_report_datatable',
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: this.api_base_path + 'wallet/common/admin/get-parsian-statements',
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: res => {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: parsianColumns,
                }
            },
        },
    }
</script>
